import { automationTherapistResponse } from '@/modules/permissionsToogle/domain/models/automationTherapistResponse'

import { axios, Response } from '..'

const updatePermissionAutomatic = (
  automationGroupId: string
): Response<automationTherapistResponse> => {
  return axios.put(`/v1/automation-groups/${automationGroupId}`)
}
export default updatePermissionAutomatic
